/**
 * 负向提示词输入组件
 */

import type { ReactElement, ChangeEvent } from 'react'
import { cn } from '@/lib/utils'
import type { FormFieldProps } from './types'

/**
 * 负向提示词输入组件
 * @param props 组件属性
 * @returns 组件元素
 */
export function NegativePromptField({
  component,
  value,
  onChange,
  error,
  disabled = false,
}: FormFieldProps): ReactElement {
  const textValue = typeof value === 'string' ? value : ''

  /**
   * 处理输入变化
   * @param event 输入事件
   */
  function handleChange(event: ChangeEvent<HTMLTextAreaElement>): void {
    onChange(event.target.value)
  }

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">
        {component.title}
        {component.is_required && (
          <span className="ml-1 text-destructive">*</span>
        )}
      </label>
      <textarea
        value={textValue}
        onChange={handleChange}
        disabled={disabled}
        rows={3}
        placeholder="描述你不想出现的元素..."
        className={cn(
          'w-full resize-none rounded-xl border bg-background p-3 text-sm outline-none transition-all',
          'focus:border-primary focus:ring-1 focus:ring-primary',
          'placeholder:text-muted-foreground/60',
          error !== undefined && 'border-destructive focus:border-destructive focus:ring-destructive',
          disabled && 'cursor-not-allowed opacity-50'
        )}
      />
      {error !== undefined && (
        <p className="text-xs text-destructive">{error}</p>
      )}
    </div>
  )
}
